import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill={color} fillRule="evenodd" d="m6.167 1.262-4.75 4.636C.462 6.831.223 8.363.842 9.59l2.197 4.358c.483.958 1.404 1.553 2.403 1.553h4.998c.98 0 1.886-.572 2.377-1.5l2.315-4.383c.653-1.236.42-2.804-.557-3.75L9.814 1.254C8.772.245 7.204.249 6.167 1.262ZM8 7.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm3 1.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" clipRule="evenodd"/>
    </svg>
)

export default class IconTemplate extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
